<template>
    <div class="wp-block-cover is-light hero-block">
        <span
            aria-hidden="true"
            class="wp-block-cover__background has-vet-gradient-background"
        ></span>
        <div class="wp-block-cover__inner-container is-layout-constrained">
            <div class="hero-header">
                <img
                    src="assets/petcare-favicon.png"
                    alt="PetCare Logo"
                    class="logo"
                />
                <h1 class="has-text-align-center">
                    <span>
                        PetCare
                    </span>
                </h1>
            </div>
            <p class="has-text-align-center hero-text">
                The PetCare mobile app enables<br />pet parents to easily manage
                their pet's<br />health directly from the palm of their hand.
            </p>
            <div
                class="wp-block-buttons is-content-justification-center is-layout-flex"
            >
                <div
                    class="wp-block-button has-custom-width wp-block-button__width-25 is-style-primary hero-button"
                >
                    <a
                        class="wp-block-button__link hero-button-text"
                        href
                        @click.prevent="petcareOnboardingModal"
                        >Let's Get Started</a
                    >
                </div>
            </div>
        </div>
        <PetCareOnboardingModal ref="petcareOnboardingModal" />
    </div>
</template>

<script>
import PetCareOnboardingModal from "@/module/settings/petcare/onboarding/modal.vue";
export default {
    name: "HeroSection",
    components: { PetCareOnboardingModal },
    methods: {
        petcareOnboardingModal() {
            this.$refs.petcareOnboardingModal.open();
        }
    }
};
</script>

<style scoped>
.wp-block-cover {
    background-repeat: no-repeat;
    min-height: 0;
    padding: 3.5rem 0;
}

@media (min-width: 1200px) {
    .wp-block-cover {
        padding: 7rem 0;
    }
}
.has-vet-gradient-background {
    background-image: linear-gradient(90deg, #f2f2f2 20%, #d8e9c2 100%);
}
.is-layout-constrained
    > :where(:not(.alignleft):not(.alignright):not(.alignfull)) {
    max-width: 1120px;
    margin-left: auto !important;
    margin-right: auto !important;
}
.wp-block-buttons {
    margin-bottom: 1rem;
    margin-top: 1rem;
}

@media (min-width: 1200px) {
    .wp-block-buttons {
        margin-bottom: 2.5rem;
        margin-top: 2.5rem;
    }
}
.wp-block-button.is-style-primary .wp-block-button__link {
    background: #678f35;
    border-color: #678f35;
    color: #ffffff;
}

.wp-block-button.is-style-primary .wp-block-button__link:active,
.wp-block-button.is-style-primary .wp-block-button__link:hover {
    background: #190d30;
    border-color: #190d30;
    color: #ffffff;
}
body .is-layout-flex {
    display: flex;
}
.is-layout-flex {
    flex-wrap: wrap;
    align-items: center;
}
.hero-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}
.logo {
    width: 50px; /* Adjust the size as needed */
    height: auto;
}
.h1,
h1 {
    color: #190d30;
    font-family: FK Display, sans-serif;
    font-size: 40px;
    font-weight: 400;
    letter-spacing: -2px;
    line-height: 1;
    margin-bottom: 0px;
}

@media (min-width: 768px) {
    .h1,
    h1 {
        font-size: 40px;
    }
}

@media (min-width: 992px) {
    .h1,
    h1 {
        font-size: 40px;
    }
}

@media (min-width: 1200px) {
    .h1,
    h1 {
        font-size: 65px;
        letter-spacing: -2px;
        margin-bottom: 0px;
    }
}
p {
    color: #333;
    font-family: "Arial", sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.5;
    margin-bottom: 1rem;
}

@media (min-width: 1200px) {
    p {
        font-size: 18px;
        letter-spacing: 0;
        margin-bottom: 1.5rem;
    }
}
.hero-text {
    margin-top: 2rem;
}
.hero-button-text {
    font-size: 18px;
    font-weight: 700;
    padding: 1.2rem;
}
.hero-block {
    margin-left: 5%;
    margin-right: 5%;
}
</style>
